module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/stretchlab-120c04143d8d8b8c1c5ad0693f2eab94.png";